<template>
  <List :searchBox="searchBox" :fullscreen="fullscreen">
    <v-list-item-group v-if="items.length" color="primary">
      <ListItemAvatarOneL
        v-for="(item, i) of items"
        :key="i"
        :title="item[itemTitle]"
        @clicked="$emit('clicked', item)"
      />
    </v-list-item-group>
    <p v-else class="text-center font-weight-bold white py-3">Nenhum registro encontrado</p>
  </List>  
</template>

<script>
import List from './List';
import ListItemAvatarOneL from './ListItemAvatarOneL';

export default {
  name: 'ListOneLItemsSelect',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    itemTitle: {
      type: String,
      default: 'title'
    },
    searchBox: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  components: {
    List,
    ListItemAvatarOneL
  }
}
</script>

<style>

</style>